<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="sm">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('import_groups') }} </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div>
                <label v-if="analyzeType == 'buy'">
                    <input type="radio" :value="'sell_analyze'" v-model="importFrom"/>
                    {{ __('from_sell_analyze') }}
                </label>
            </div>
            <div>
                <label v-if="analyzeType == 'sell'">
                    <input type="radio" :value="'buy_analyze'" v-model="importFrom"/>
                    {{ __('from_buy_analyze') }}
                </label>
            </div>


        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('cancel')}}</button>
                </div>
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-primary" v-on:click="importGroups()">{{__('OK')}}</button>
                </div>

            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalImportContractorGroup",
    data: function () {
        return {
            visible: false,
            importFrom : this.analyzeType == 'sell' ? 'buy_analyze' : 'sell_analyze',
        }
    },
    props:{
        analyzeType: {
            type: String
        },
    },
    methods:{
      importGroups()  {
          this.$emit('importContractorGroups',this.importFrom)
      }
    },
}
</script>

<style scoped>

</style>
